<h2>Curve Mapping</h2>

<app-maintenance-table [apiUrl]="url" [columnDefs]="colDefs" [columnDefs]="colDefs" [keyFields]="keyColumns"
    [mandatoryFields]="mandatory" [validators]="validators"></app-maintenance-table>